import { serverFetch } from '../server';

export const openwindow = (url)  => {
    const width = 400;
    const height = 600;
    const left = window.innerWidth / 2 - width / 2;
    const top = window.innerHeight / 2 - height / 2;
    window.open(url,'_blank', `width=${width},height=${height},left=${left},top=${top},noopener`);
}

export const authvk = (provider, clbState)  => {
    const location = window.location;
    const redirect_uri = `https://rd.sport24.cloud?redirect=${location.protocol}//${location.hostname}${location.port ? ":" + location.port : ""}/vk`;
    //const redirect_uri = `https://rd.sport24.cloud?redirect=${process.env.REACT_APP_API_BASE_URL}/vk`;
    //const redirect_uri = `https://rd.sport24.cloud/vk`;
    //const redirect_uri = `${process.env.REACT_APP_API_BASE_URL}/vk`;
    serverFetch(`vk/state?redirectUrl=${redirect_uri}&backUrl=${window.location.href}`)
        .then((data) => {
            const { state, codeChallenge } = data;
            clbState(state);
            const CLIENT_ID = process.env.REACT_APP_VK_CLIENT_ID;
            const scope = "email phone"; // Список прав доступа, которые нужны приложению. Значения в списке разделяются пробелами, например: email phone notify.
            const prompt = "login"; // none login consent 
            const code_challenge_method = 's256';
            const params = new URLSearchParams({
                response_type: 'code', // Требуемый ответ. При запросе кода подтверждения следует указать значение code
                client_id: CLIENT_ID, // Идентификатор приложения, которое запрашивает авторизацию
                code_challenge: codeChallenge,
                code_challenge_method,
                redirect_uri,
                state,
                scope,
                provider,
                prompt,
            });
            const url = `https://id.vk.ru/authorize?${params.toString()}`;
            //console.log(url)
            openwindow(url);
        })
        .catch(e => console.log(`Ошибка ${e.messge}`));
}

export const setAccessToken = (accessToken) => {
    console.log("accessToken", accessToken);
    window.accessToken = accessToken;
}